module.exports = __webpack_public_path__ + "img/83.a1efed23.jpg";